import React from 'react';
import './App.css';
import Navi from './components/Navi';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom' ;
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
// import Footer from './components/Footer';

function App() {
  return (
    <div>
      <Router>
        <Navi />
        <Switch>
          <Route path='/' exact component={Hero} />
          <Route path='/about' exact component={About} />
          <Route path='/services' exact component={Services} />
          <Route path='/contact_us' exact component={Contact} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
